import React, { useEffect, useState } from "react";
import MonthLetterDatePicker from "../Customer/Component/MonthLetterDatePicker";
import "react-datepicker/dist/react-datepicker.css";
import MonthLetterTimePicker from "../Customer/Component/MonthLetterTimePicker";
import { Button } from "@mui/material";
import { TiTick } from "react-icons/ti";
import SearchableDropdown from "../../../Component/DigitalMarketing/Forms/SearchableDropdown";
import TextArea from "../../../Component/DigitalMarketing/Forms/TextArea";
import { Col, Row } from "react-bootstrap";
import {
  useAddAppointmentMutation,
  useGetFilterCustomerListQuery,
  useUpdateAppointmentMutation,
} from "../../../Service/appoinment";
import { useNavigate } from "react-router-dom";
import { SetAppointmentLabel, SetReminderLabel } from "./Utils";
import { useAddReminderMutation } from "../../../Service/reminder";
import TooltipMsg from "../../../Component/DigitalMarketing/TooltipMsg";
import SelectMenuItem from "../../../Component/DigitalMarketing/SelectMenuItem";
import { Prev } from "react-bootstrap/esm/PageItem";
function CustomerReminders(props) {
  const { id, callBackforErrorMessage, openSnackBar, details } = props;
  const [name, setname] = useState("");
  const [reminder, setReminder] = useState({});
  const [selectedValue, setSelectedValue] = useState("1");
  const navigate = useNavigate();
  const response = useGetFilterCustomerListQuery(name);
  const [addReminder] = useAddReminderMutation();
  const reminderOptions = [
    { name: "2nd Dose HPV", id: "2nd Dose HPV" },
    { name: "3rd Dose HPV", id: "3rd Dose HPV" },
    { name: "Blood report collection", id: "Blood report collection" },
    { name: "Customer reminders", id: "Customer reminders" },
    // {name:"Review appointment" ,id:"Review appointment"}
  ];
  const Option = Array.isArray(response?.data)
    ? response?.data
        ?.map((item: any) => {
          if (item.phone_number) {
            return {
              value: item.customerId,
              label: `${item.name} ${item.phone_number}`,
              label1: item.name,
            };
          }
          return null;
        })
        .filter((item) => item !== null)
    : [];
  const path = window.location.pathname;
  // const [time, setTime] = useState(null);
  // const [date, setDate] = useState(null);

  const OnHandleChange = (event) => {
    const { name, value } = event.target;
    setReminder((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSelectChange = (event:any) => {
    setReminder((prev)=>({
      ...prev,
      templateName:event.target.value
    }))
    setSelectedValue(event.target.value);
  };
  
  const onSubmit = async () => {
    let data: any = {
      ...reminder,
     
    };
    // console.log(data.fromDate < data.toDate);
    console.log(data)
    if (
      data.customerId &&
      data.fromDate &&
      data.toDate &&
      data.fromDate <= data.toDate &&
      data.templateName
    ) {
      try {
        const payload = await addReminder(data).unwrap();
        openSnackBar("Added successfully");
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      } catch (error: any) {
        openSnackBar(error.data.error, "error");
      }
    } else {
      if (data.fromDate >= data.toDate) {
        // console.log("dsfdsaf");
        return openSnackBar(
          "End Date should be greater than Start date!",
          "error"
        );
      }
      openSnackBar("Please fill all data before submit!", "error");
    }
  };
  useEffect(() => {
    details && setReminder({ ...details, reason: "" });
  }, [details]);

  return (
    <>
      <li>
        <div className="mb-2">
          <span className="title">New Reminder</span>
          <Button onClick={() => onSubmit()} variant="contained" id="btn-blue">
            <TiTick style={{ marginTop: "-2px" }} />
            &nbsp;Set
          </Button>
        </div>
      </li>
      <li>
        <Row>
          <Col className="mt-2" md={8}>
            <SearchableDropdown
              setname={setname}
              Option={Option}
              labelClass="f-14"
              key_name="customerId"
              handleChange={OnHandleChange}
              label="Customer Name"
            />
          </Col>
          <Row>
            <Col className="mt-2" md={8}>
                <SelectMenuItem
                  styles={"select"}
                  option={reminderOptions.map(item => ({ value: item.id, label: item.name }))}
                  name="templateName"
                  value={selectedValue}
                  handleChange={handleSelectChange}
                  label="Notifications"
                />
            </Col>
          </Row>
          <Col className="mt-2" md={12}>
            <Row>
              {SetReminderLabel.map((item, index) => {
                return (
                  <Col md={6} key={index}>
                    <item.tag
                      {...item}
                      labelStyle="f-14"
                      handleChange={OnHandleChange}
                    />
                  </Col>
                );
              })}
            </Row>
          </Col>
          {/* <Col className="mt-2" md={12}>
            <small>
              How to select Reminder date{" "}
              <TooltipMsg msg="Your reminders will be sent only the last 5 days until the date of your appointment.
" />{" "}
            </small>
          </Col> */}
          <Col className="mt-2" md={12}>
            <TextArea
              label="Type your reminder message"
              handleChange={OnHandleChange}
              placeholder="don't forget your test reports"
              key_name="reason"
              labelStyle="f-14"
            />
          </Col>
        </Row>
      </li>
    </>
  );
}

export default React.memo(CustomerReminders);
